import { gql } from "@apollo/client";

export const GET_DASHBOARD_INSIGHTS = gql`
 query GetDashboardInsights($brandName: String, $startDate: String, $endDate: String) {
  getDashboardInsights(brandName: $brandName, startDate: $startDate, endDate: $endDate) {
    grossSales
    orders
    ordersFulFilled
    cartAbandoment
    totalSalesByProduct {
      name
      totalCount
      totalPrice
    }
    totalSalesByState {
      name
      totalCount
      totalPrice
    }
    totalSales {
      id
      orderId
      buyerId
      sellerId
      brandName
      createdAt
      totalPrice
      productPrice
      state
      source
      productId
      paymentStatus
      isCancelRequestSent
      isRefundRequestSent
      receiptUrl
      orderStatus {
        status
        timestamp
      }
      shopify {
        orderId
        orderDate
        fulfillmentStatus
        deliveryMethod
        deliveryStatus
        tags
        shopifyItems {
          id
          title
          name
          quantity
          price
          size
          imgUrl
          outOfStock
          variant {
            id
          }
          image {
            url
          }
        }
      }
    }
  }
}
`;